// extracted by mini-css-extract-plugin
export default {"wedo":"WhatWeDo_wedo__k9TrH","wedo__row":"WhatWeDo_wedo__row__3mx06","wedo__item":"WhatWeDo_wedo__item__FzgdF","wedo__card":"WhatWeDo_wedo__card__3e5K8"};